import moment from 'moment.lib';

export default ({ collection, endDate, startDate }) => {
	return collection.filter((invoice) => {
		const mDate = moment(invoice.billingDate).utc();
		return mDate.isSameOrAfter(startDate, 'day') && mDate.isSameOrBefore(endDate, 'day');
	});
};
